import debounce from 'debounce';
import { ChangeEvent, useCallback, useState } from 'react';

const useListSearch = () => {
  const [search, setSearch] = useState<string>('');
  const [searchTerm, setSearchTerm] = useState<string>('');

  const updateSearchTerm = useCallback(
    debounce((newSearch: string) => {
      setSearchTerm(newSearch.trim().toLowerCase());
    }, 200),
    [],
  );

  const onSearchValueChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const newSearch = e.target.value || '';
      setSearch(newSearch);
      updateSearchTerm(newSearch);
    },
    [updateSearchTerm],
  );

  const clearSearch = useCallback(() => {
    updateSearchTerm.clear();
    setSearch('');
    setSearchTerm('');
  }, [updateSearchTerm]);

  return { search, searchTerm, onSearchValueChange, clearSearch };
};

export default useListSearch;
